export default __webpack_public_path__ + "9ef16a874a0d0c5f088667b5e850e2e6.svg";